import { render } from "./tech.vue?vue&type=template&id=3de894b8"
import script from "./tech.vue?vue&type=script&lang=ts"
export * from "./tech.vue?vue&type=script&lang=ts"
script.render = render

export default script